import Home from './Home.data-manager-stags-versions.vue'

export default {
  Home
}